var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99973 10.881H3.99991C3.44767 10.881 3 11.3287 3 11.8809V15.8805C3 16.4328 3.44767 16.8804 3.99991 16.8804H5.99973C6.55196 16.8804 6.99964 16.4328 6.99964 15.8805V11.8809C6.99964 11.3287 6.55196 10.881 5.99973 10.881Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6789 10.881H17.6791C17.1269 10.881 16.6792 11.3287 16.6792 11.8809V15.8805C16.6792 16.4328 17.1269 16.8804 17.6791 16.8804H19.6789C20.2312 16.8804 20.6788 16.4328 20.6788 15.8805V11.8809C20.6788 11.3287 20.2312 10.881 19.6789 10.881Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3382 10.8793C19.3734 8.84424 18.6065 6.87705 17.2033 5.40274C15.8001 3.92842 13.8732 3.06535 11.8389 3C9.80456 3.06535 7.87764 3.92842 6.47442 5.40274C5.0712 6.87705 4.30435 8.84424 4.33954 10.8793",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3086 19.6987H17.6382C18.1686 19.6987 18.6773 19.488 19.0523 19.1129C19.4273 18.7379 19.638 18.2292 19.638 17.6988V16.8789",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8392 21C12.6676 21 13.3391 20.3285 13.3391 19.5001C13.3391 18.6718 12.6676 18.0002 11.8392 18.0002C11.0109 18.0002 10.3394 18.6718 10.3394 19.5001C10.3394 20.3285 11.0109 21 11.8392 21Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f667dc1773e756ff5602187a31dbf085.svg";
export { ForwardRef as ReactComponent };